import React, { FC } from 'react';
import styles from './CareTypeInfo.module.css';

const CareTypeInfo: FC<{
    children?: React.ReactNode;
    title: string;
    subtitle: any;
    style?: string;
}> = ({ title, subtitle, children }) => {
    return (
        <p className={styles.careTypeInfoWrapper}>
            <span className={styles.careTypeInfoTitle}>{title}</span>
            <span className={styles.careTypeInfoSubtitle}>{subtitle}</span>
            <span className={styles.careTypeInfoChildren}>{children}</span>
        </p>
    );
};

export default CareTypeInfo;
